import { Provider } from '@angular/core';
import { CUSTODIS_COMPANY_ID, CUSTODIS_MODULE_CONFIG, CustodisModuleConfig } from './core/custodis.config';

/**
 * Supplies the Custodis module's API endpoints.
 *
 * On the lazy route (preferred — keeps the config with the feature):
 *
 *   {
 *     path: 'custodis',
 *     loadChildren: () => import('./custodis-module/custodis.module').then(m => m.CustodisModule),
 *     providers: provideCustodisModule({
 *       custodisApiUrl: environment.apiConfig.custodisAPI.endpoint,
 *       identityApiUrl: environment.apiConfig.IdentityAPI.endpoint,
 *     }),
 *   }
 */
export function provideCustodisModule(
  config: CustodisModuleConfig,
  /**
   * Builds the getter for the company currently open in this tab. BC_Corporate's customer
   * endpoints are company-scoped, and the module must not reach into the host's CompaniesService
   * itself, so the host supplies this instead:
   *
   *   () => { const companies = inject(CompaniesService);
   *           return () => companies.managedCompanyId || null; }
   *
   * A FACTORY, not a plain value: Angular runs it inside an injection context, so `inject()` is
   * legal in it. The getter it returns closes over the resolved service and can then be called at
   * any time — a `useValue` arrow calling `inject()` would throw the moment a component used it
   * outside construction.
   */
  companyIdFactory: () => () => number | null,
): Provider[] {
  return [
    { provide: CUSTODIS_MODULE_CONFIG, useValue: config },
    { provide: CUSTODIS_COMPANY_ID, useFactory: companyIdFactory },
  ];
}
